import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { useTranslation } from 'react-i18next';

interface DescriptionInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const DescriptionInput: React.FC<DescriptionInputProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Textarea
        id="description"
        className="bg-card"
        placeholder={t('agent.new.description.translation')}
        value={value}
        autogrow
        onChange={e => {
          if (e.target.value.length <= 300) onChange(e.target.value);
        }}
        disabled={disabled}
        maxLength={300}
      />
      <div className="text-right text-xs text-muted-foreground">
        {value.length}/300
      </div>
    </div>
  );
};

export default DescriptionInput;
